import { render, staticRenderFns } from "./CabezeraCS.vue?vue&type=template&id=487388d0&"
import script from "./CabezeraCS.vue?vue&type=script&lang=ts&"
export * from "./CabezeraCS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('487388d0', component.options)
    } else {
      api.reload('487388d0', component.options)
    }
    module.hot.accept("./CabezeraCS.vue?vue&type=template&id=487388d0&", function () {
      api.rerender('487388d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/CabezeraCS.vue"
export default component.exports